export default {
  name: 'ItemDialog',
  props: {
    initialVisible: {
      type: Boolean,
      default: false
    },
    input_type: {
      type: String,
      default: ""
    },
    target_item: Object
  },
  emits: ['updateflag', 'closed'], // ここにカスタムイベントを追加
  data() {
    return {
      dialog: this.initialVisible,
      form: false,
      regist_btn_loading: false,
      update_btn_loading: false,
      delete_btn_loading: false,
      up_iid: "",
      up_name: "",
      up_type: "",
      up_ex_date: "",
      up_cat: "",
      up_img: [],
      up_count: "1",
      up_note: "",
      imagePreview: null
    };
  },
  computed: {
    categoryOptions() {
      // Store からカテゴリーリストを取得
      return this.$store.state.category_list;
    },
    enhancedCategoryOptions() {
      // 現在のcat_idがcategoryOptionsに存在するか確認
      const isCatIdValid = this.categoryOptions.some(cat => cat.cat_id === this.up_cat);
      
      // 存在しない場合「不明」を追加
      if (!isCatIdValid && this.up_cat) {
        return [
          ...this.categoryOptions,
          { cat_id: this.up_cat, name: this.$t('item_dialog.unknown') }
        ];
      }
      
      return this.categoryOptions;
    }
  },
  watch: {
    initialVisible(newVal) {
      this.dialog = newVal;
    },
    target_item(newVal) {
      if (newVal) {
        this.up_iid = newVal.iid;
        this.up_name = newVal.name;
        this.up_ex_date = newVal.ex_date;
        this.up_cat = newVal.cat || '';
        this.up_type = newVal.type;
        this.up_ext = newVal.ext;
        this.up_count = newVal.count;
        this.up_note = newVal.note;
        if (newVal.ext) {
          this.imagePreview = `${this.$store.state.img_baseurl}${this.$store.state.user_info.user_id}/${newVal.iid}${newVal.ext}`;
        } else {
          this.imagePreview = "";
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit('closed');
    },
    handleOutsideClick() {
      this.closeDialog();
    },
    triggerCameraInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    handleFileChange(event) {
      const fileInput = event.target;
      const file = event.target.files[0];

      fileInput.value = '';
      if (file && file.type && file.type.startsWith('image/')) {
        this.up_img = file;
        const reader = new FileReader();
        reader.onload = e => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.imagePreview = null;
      }
    },
    clearImage() {
      this.imagePreview = null;
      this.up_img = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    async regist_item() {
      let jsonbody = {
        api_type: "putitem",
        user_id: this.$store.state.user_info.user_id,
        cat: this.up_cat,
        count: this.up_count,
        type: 0,
        name: this.up_name,
        note: this.up_note,
        ex_date: this.up_ex_date,
        filedata: this.imagePreview
      };

      this.regist_btn_loading = true;
      try {
        await this.axios.post(`${this.$store.state.api_baseurl}putitem`, jsonbody, this.$store.state.post_headers);
        this.$emit('updateflag'); // カスタムイベントを発火
        this.closeDialog();
      } catch (error) {
        console.error(error);
        alert(error);
      } finally {
        this.regist_btn_loading = false;
      }
    },
    async update_item() {
      let jsonbody = {
        api_type: "updateitem",
        iid: this.up_iid,
        user_id: this.$store.state.user_info.user_id,
        cat: this.up_cat,
        count: this.up_count,
        type: this.up_type,
        name: this.up_name,
        note: this.up_note,
        ex_date: this.up_ex_date,
        filedata: this.imagePreview
      };

      this.update_btn_loading = true;
      try {
        await this.axios.post(`${this.$store.state.api_baseurl}updateitem`, jsonbody, this.$store.state.post_headers);
        this.$emit('updateflag'); // カスタムイベントを発火
        this.closeDialog();
      } catch (error) {
        console.error(error);
        alert(error);
      } finally {
        this.update_btn_loading = false;
      }
    },
    async delete_item() {
      let jsonbody = {
        api_type: "deleteitem",
        iid: this.up_iid,
        user_id: this.$store.state.user_info.user_id
      };

      this.delete_btn_loading = true;
      try {
        await this.axios.post(`${this.$store.state.api_baseurl}deleteitem`, jsonbody, this.$store.state.post_headers);
        this.$emit('updateflag'); // カスタムイベントを発火
        this.closeDialog();
        this.clearItem();
      } catch (error) {
        console.error(error);
        alert(error);
      } finally {
        this.delete_btn_loading = false;
      }
    },
    clearItem() {
      this.up_iid = "";
      this.up_name = "";
      this.up_type = "";
      this.up_ex_date = "";
      this.up_cat = "";
      this.up_img = [];
      this.up_count = "1";
      this.up_note = "";
      this.imagePreview = null;
    },
    required(v) {
      return !!v || this.$t('item_dialog.required_field');
    }
  }
};
